<form [formGroup]=trackTypeForm>
    <div mat-dialog-content class="dialog-content">
        <h1 mat-dialog-title>Select Type</h1>
        <mat-radio-group aria-label="Select an option" formControlName="typeOptions">
            <mat-radio-button value="polygon">Polygon</mat-radio-button>
            <mat-radio-button value="route">Route</mat-radio-button>
          </mat-radio-group>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button (click)="cancel()">Cancel</button>
        <button mat-raised-button color="primary"type="submit" (click)="onSubmit()">Ok</button>
    </div>
</form>